import React from 'react';
import Navbar from '../../components/Homepage/Navbar/Navbar';
import Footer from '../../components/Homepage/Footer/Footer';
import placementCellData from '../../data/placementCell';
import './About.css';

const About = () => {
  const { staff, aboutContent } = placementCellData;

  return (
    <>
      <Navbar />
      <div id="placement-about-page">
        <div id="placement-about-container">
          {/* Left Side - Staff Data */}
          {/* <div id="placement-staff-section">
            <h2 id="placement-staff-title">Placement Cell Team</h2>
            <div id="placement-staff-grid">
              {staff.map((member) => (
                <div key={member.id} className="placement-staff-card">
                  <div className="placement-staff-image-container">
                    <img 
                      src={member.photo} 
                      alt={member.name}
                      className="placement-staff-image"
                    />
                  </div>
                  <div className="placement-staff-info">
                    <h3 className="placement-staff-name">{member.name}</h3>
                    <p className="placement-staff-designation">{member.designation}</p>
                    <div className="placement-staff-contact">
                      <p className="placement-staff-email">
                        <i className="far fa-envelope"></i>
                        <a href={`mailto:${member.email}`} className="placement-email-link">
                          {member.email}
                        </a>
                      </p>
                      <p className="placement-staff-phone">
                        <i className="fas fa-phone"></i>
                        <a href={`tel:+91${member.phone}`} className="placement-phone-link">
                          {member.phone}
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div> */}

          {/* Right Side - About Content */}
          {/* <div id="placement-about-section">
            <h2 id="placement-about-title">{aboutContent.title}</h2>
            <p id="placement-about-description">{aboutContent.description}</p>
            
            <div id="placement-objectives-section">
              <h3 id="placement-objectives-title">Activities of the Placement Cell include</h3>
              <ul id="placement-objectives-list">
                {aboutContent.objectives.map((objective, index) => (
                  <li key={index} className="placement-objective-item">{objective}</li>
                ))}
              </ul>
            </div>
          </div> */}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default About;
